import { L10n, loadCldr, setCulture, setCurrencyCode } from '@syncfusion/ej2-base';
import ptBR from '@syncfusion/ej2-locale/src/pt-BR.json';

import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import * as ptNumbers from 'cldr-data/main/pt/numbers.json';
import * as ptCaGregorian from 'cldr-data/main/pt/ca-gregorian.json';
import * as ptTimeZoneNames from 'cldr-data/main/pt/timeZoneNames.json';
import * as ptCurrencies from 'cldr-data/main/pt/currencies.json';


export function setupLocale() {
    L10n.load(ptBR);
    loadCldr(
        numberingSystems,
        { main: { 'pt-BR': ptNumbers.main.pt } },
        { main: { 'pt-BR': ptCaGregorian.main.pt } },
        { main: { 'pt-BR': ptTimeZoneNames.main.pt } },
        { main: { 'pt-BR': ptCurrencies.main.pt } }
    );

    setCulture('pt-BR');
    setCurrencyCode('BRL');
}
